import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { getMainIconProps as C } from "./index.es2444.js";
function o(t) {
  const { outline: i, fill: d, size: l, innerElementFill: p } = C(t);
  return /* @__PURE__ */ n(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n("g", { clipPath: "url(#clip0_260_3388)", children: [
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              d: "M3.375 7.45312C1.74713 7.45312 0.421875 6.12787 0.421875 4.5V0.421875H17.5781V4.5C17.5781 6.12787 16.2529 7.45312 14.625 7.45312C13.3112 7.45312 12.1945 6.58988 11.8125 5.40101C11.4305 6.58988 10.3138 7.45312 9 7.45312C7.68617 7.45312 6.56947 6.58988 6.1875 5.40101C5.80553 6.58988 4.68883 7.45312 3.375 7.45312Z",
              fill: d
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              d: "M1.875 7.04284V17.25H16.125V7.04284C16.4089 6.87469 16.6624 6.66038 16.875 6.41033V18H1.125V6.41033C1.33764 6.66038 1.59112 6.87469 1.875 7.04284Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              d: "M1.125 0.421875V0.0500488H16.875V0.421875H1.125Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M0.046875 0.046875V4.5C0.046875 6.33498 1.54002 7.82812 3.375 7.82812C4.55682 7.82812 5.59685 7.20877 6.1875 6.27763C6.77816 7.20877 7.81818 7.82812 9 7.82812C10.1818 7.82812 11.2218 7.20877 11.8125 6.27763C12.4032 7.20877 13.4432 7.82812 14.625 7.82812C16.46 7.82812 17.9531 6.33498 17.9531 4.5V0.046875H0.046875ZM11.2969 0.796875H6.42188V4.5C6.42188 5.92077 7.57923 7.07812 9 7.07812C10.1071 7.07812 11.0543 6.37538 11.4185 5.39285C11.3393 5.1086 11.2969 4.80916 11.2969 4.5V0.796875ZM5.67188 4.5V0.796875H0.796875V4.5C0.796875 5.92077 1.95423 7.07812 3.375 7.07812C4.48211 7.07812 5.42927 6.37538 5.79352 5.39285C5.71426 5.10861 5.67188 4.80916 5.67188 4.5ZM12.0469 4.5V0.796875H17.2031V4.5C17.2031 5.92077 16.0458 7.07812 14.625 7.07812C13.2042 7.07812 12.0469 5.92077 12.0469 4.5Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M5.25 10.875V17.25H8.25V10.875H5.25ZM5 10.125C4.72386 10.125 4.5 10.3489 4.5 10.625V18H9V10.625C9 10.3489 8.77614 10.125 8.5 10.125H5Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M10.3125 12.9375C10.3125 12.7304 10.4804 12.5625 10.6875 12.5625H14.0625C14.2696 12.5625 14.4375 12.7304 14.4375 12.9375C14.4375 13.1446 14.2696 13.3125 14.0625 13.3125H10.6875C10.4804 13.3125 10.3125 13.1446 10.3125 12.9375Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M10.3125 10.6875C10.3125 10.4804 10.4804 10.3125 10.6875 10.3125H14.0625C14.2696 10.3125 14.4375 10.4804 14.4375 10.6875C14.4375 10.8946 14.2696 11.0625 14.0625 11.0625H10.6875C10.4804 11.0625 10.3125 10.8946 10.3125 10.6875Z",
              fill: i
            }
          )
        ] }),
        /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_260_3388", children: /* @__PURE__ */ e(
          "rect",
          {
            shapeRendering: "optimizeQuality",
            width: "18",
            height: "18",
            fill: p
          }
        ) }) })
      ]
    }
  );
}
o.__tags = [];
export {
  o as VenueIcon
};
//# sourceMappingURL=index.es376.js.map
